module.exports = __webpack_public_path__ + "img/trinapp-cde.dca42928.png";